/* eslint eqeqeq: "off" */

/**
 * ==============================================================
 * Documentation
 * ==============================================================
 *
 * ===================================
 * Log.debug(tag, message, listOfVars)
 * ===================================
 * tag - [String|Object] a message to display to 'group' log messages (i.e. like a func name or class name)
 * message - [String] the message to want to log
 * listOfVars - [Array] the list of objects to be paired with the format specifiers (see below for example)
 *
 * extras: Please see link for more info on Format specifiers: (https://developers.google.com/chrome-developer-tools/docs/console-api#consolelogobject_object)
 *
 * ==============================================================
 * Example of how-to-use:
 * ==============================================================
 *
 * // Set the level of logging to 'debug'
 * Log.configure("debug");                          // verbose,debug,info,warn,error,off
 *
 * // Log something
 * Log.debug("hello world");                        // DEBUG - [Unknown class] - 2013-09-10 11:45:03 - hello world
 *
 * // Log something with a TAG
 * Log.info("MyFunc", "hello world");               // INFO - [MyFunc] - 2013-09-10 11:45:03 - hello world
 *
 * // Log something with a JS obj inline (wrong way)
 * Log.error("MyFunc", "hello world : [obj:" + myJsObj + "]");  // ERROR - [MyFunc] - 2013-09-10 11:45:03 - hello world : [obj:[Object object]]
 *
 * // Log something with a JS obj using format specifiers (correct way)
 * Log.verbose("MyFunc", "hello world : [obj:%O]", [myJsObj]);      // VERBOSE - [MyFunc] - 2013-09-10 11:45:03 - hello world : [obj:{a drilldown the console will provide}]
 *
 */
function Log() {
    /***********************************
     * Private Constants
     ***********************************/

    var VERBOSE = 0;
    var DEBUG = 1;
    var INFO = 2;
    var WARN = 3;
    var ERROR = 4;
    var OFF = 99;

    /***********************************
     * Private Variables
     ***********************************/

    // Set the default log level to INFO
    var logLevel = WARN;
    var filter;

    /***********************************
     * Private Methods
     ***********************************/

    var log = function (level, tag, message, listOfVars) {
        if (message == undefined) {
            message = tag;
            tag = `[Unknown class]`;
        }

        if (tag == undefined) {
            tag = `[Unknown class]`;
        } else if (typeof tag === `function`) {
            tag = tag.prototype.toString();
        } else if (typeof tag === `object`) {
            tag = tag.toString();
        }

        if (filter == undefined || tag.toString().indexOf(filter) != -1) {
            if (typeof console !== `undefined`) {
                var messageToLog = `${level} - ${tag} - ${timestamp()} - ${message}`;

                if (listOfVars != undefined) {
                    listOfVars.unshift(messageToLog);
                    console.log.apply(console, listOfVars);
                } else {
                    console.log(messageToLog);
                }
            }
        }
    };

    var timestamp = function () {
        var date = new Date();

        var year = date.getFullYear();
        var month =
            date.getMonth() >= 10 ? date.getMonth() : `0${date.getMonth()}`;
        var day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`;
        var hours =
            date.getHours() >= 10 ? date.getHours() : `0${date.getHours()}`;
        var minutes =
            date.getMinutes() >= 10
                ? date.getMinutes()
                : `0${date.getMinutes()}`;
        var seconds =
            date.getSeconds() >= 10
                ? date.getSeconds()
                : `0${date.getSeconds()}`;
        var millis =
            date.getMilliseconds() >= 100
                ? date.getMilliseconds()
                : date.getMilliseconds() >= 10
                ? `0${date.getMilliseconds()}`
                : `00${date.getMilliseconds()}`;

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${millis}`;
    };

    /***********************************
     * Public Methods
     ***********************************/

    this.configure = function (pLogLevel) {
        switch (pLogLevel) {
            case `verbose`:
                logLevel = VERBOSE;
                break;
            case `debug`:
                logLevel = DEBUG;
                break;
            case `info`:
                logLevel = INFO;
                break;
            case `warn`:
                logLevel = WARN;
                break;
            case `error`:
                logLevel = ERROR;
                break;
            default:
                logLevel = OFF;
                break;
        }
    };

    this.filter = function (pTag) {
        filter = pTag;
    };

    this.verbose = function (tag, message, listOfVars) {
        if (logLevel <= VERBOSE) {
            log(`VERBOSE`, tag, message, listOfVars);
        }
    };

    this.debug = function (tag, message, listOfVars) {
        if (logLevel <= DEBUG) {
            log(`DEBUG`, tag, message, listOfVars);
        }
    };

    this.info = function (tag, message, listOfVars) {
        if (logLevel <= INFO) {
            log(`INFO`, tag, message, listOfVars);
        }
    };

    this.warn = function (tag, message, listOfVars) {
        if (logLevel <= WARN) {
            log(`WARN`, tag, message, listOfVars);
        }
    };

    this.error = function (tag, message, listOfVars) {
        if (logLevel <= ERROR) {
            log(`ERROR`, tag, message, listOfVars);
        }
    };
}
Log.prototype = {
    toString: function () {
        return `[Grby.Lib.Log class]`;
    }
};

export default new Log();
